import React, { useState } from "react";
import {
  Box,
  ListItem,
  List,
  Image,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { menu } from "../../Constant";
// i
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import { getUserDetails } from "../../redux/auth/AuthSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { useEffect } from "react";
import cuLogo from "../../assets/images/cu_logo.png";
import cuIcon from "../../assets/images/cu_icon.png";
import {
  IoChevronBackCircleSharp,
  IoChevronForwardCircleSharp,
} from "react-icons/io5";
import { AnimatePresence, motion } from "framer-motion";

function Sidebar({ isOpen, setIsOpen, isMobile }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { userData } = useSelector((state) => state.auth);

  const decodedUser = jwt_decode(user);

  const userId = decodedUser?._id;

  const getUserData = () => {
    try {
      const result = dispatch(getUserDetails(userId));
      unwrapResult(result);
    } catch (error) {
      unwrapResult(error);
    }
  };

  useEffect(() => {
    getUserData();
  }, []);

  const variants = {
    expanded: { width: "250px" },
    collapsed: { width: "100px" },
    hidden: { width: "0px" },
  };

  return (
    <AnimatePresence>
      {(isOpen || !isMobile) && (
        <motion.div
          initial={isMobile ? "hidden" : "expanded"}
          animate={isOpen ? "expanded" : "collapsed"}
          exit={{ width: 0 }}
          variants={variants}
          style={{
            background: "white",
            height: "calc(100vh - 0px)",
            position: "fixed",
            zIndex: 10,
            overflowY: "auto",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
          }}
        >
          {!isMobile && (
            <Box
              display={"flex"}
              justifyContent={"right"}
              paddingRight="2rem"
              paddingTop="2rem"
              alignItems={"center"}
            >
              <Box
                display={"flex"}
                alignItems="center"
                cursor={"pointer"}
                onClick={() => setIsOpen((prev) => !prev)}
              >
                {!isOpen ? (
                  <IoChevronForwardCircleSharp color={"#52BBFF"} size={30} />
                ) : (
                  <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
                )}
              </Box>
            </Box>
          )}
          <Box paddingTop={"2rem"} paddingLeft={isOpen ? "1.5rem" : "1.25rem"}>
            {isOpen ? (
              <Image src={cuLogo} width="200px" />
            ) : (
              <Image src={cuIcon} width="50px" />
            )}
          </Box>
          <Box
            marginTop={"10"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            // paddingLeft={"40px"}
          >
            <Box width={"100%"}>
              <List spacing={4}>
                {userData?.role
                  ? menu(userData?.role).map((item) => {
                      return (
                        <Tooltip label={item.text} isDisabled={isOpen}>
                          <ListItem
                            key={item?.id}
                            fontSize={"16px"}
                            color={
                              pathname.includes(item?.path)
                                ? "#fff"
                                : "brand.blue"
                            }
                            fontWeight={"500"}
                            display={"flex"}
                            alignItems={"center"}
                            gap={"20px"}
                            paddingLeft={isOpen ? "24px" : "20px"}
                            paddingRight="12px"
                            py="0.4rem"
                            onClick={() => {
                              navigate(item?.path);
                              if (isMobile) {
                                setIsOpen(false);
                              }
                            }}
                            cursor={"pointer"}
                            borderTopRightRadius="100px"
                            borderBottomRightRadius={"80px 80px"}
                            background={
                              pathname.includes(item?.path)
                                ? "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 35%, rgba(164,206,255,1) 100%)"
                                : "transparent"
                            }
                          >
                            <Box
                              css={{
                                path: {
                                  fill: pathname.includes(item?.path)
                                    ? "white"
                                    : "brand.blue",
                                },
                              }}
                              as="span"
                            >
                              {item.icon}
                            </Box>
                            {isOpen ? item.text : ""}
                          </ListItem>
                        </Tooltip>
                      );
                    })
                  : null}
              </List>
            </Box>
          </Box>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default Sidebar;
